import {createAction} from 'redux-actions';
import {getContentPartners} from '@pluto/rest';
import {ContentPartnersFilterParams} from '../ContentPartnersTypes';

export const SET_CONTENT_PARTNERS = 'SET_CONTENT_PARTNERS';

export const setContentPartnersAction = createAction(
    SET_CONTENT_PARTNERS,
    async (params: ContentPartnersFilterParams) => {
        return await getContentPartners(params);
    }
);
